import React, { useMemo, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./seatBooking.css";
import { getPassengerType } from "../../../../components/commonClass/CommonValidation";

const SeatBooking = (props:any) => {

  const { seatDynamicCollection, setSeatDynamicCollection, flight, flightIndex, pass } = props;

  //#region get flight wise data in row
  const row = useMemo(() =>
    seatDynamicCollection?.length > 0 ?
      seatDynamicCollection?.find((fin:any) => fin?.rowSeats?.[0]?.seats?.[0]?.flightNumber === flight?.flightNumber)
      :
      [], [seatDynamicCollection, flight])
  //#endregion

  //#region  get max count of columns length
  const columnsCount = useMemo(() => {
    return row?.rowSeats?.length > 0 ? Math.max(...row?.rowSeats?.map((ss:any) => ss?.seats?.length)) : [];
  }, [row]);
  //#endregion

  //#region get columns of max columns length count 
  const columns = useMemo(() => {
    let column:any = [];
    let temp:any = [];
    if (row?.rowSeats?.length > 0) {
      row?.rowSeats?.find((ss:any) => ss?.seats?.length === columnsCount)?.seats?.map((col:any, index:any, arr:any) => {
        column.push(col);
      })
      temp = [...column];
      column?.unshift({ seatNo: '' })
      column?.push({ seatNo: '' })
    }
    return { column: column, temp: temp };
  }, [columnsCount, row]);
  //#endregion

  //#region add gallary beside seats
  const setGallarySpace = (index:any, arr:any) => {
    if (arr[index]?.SeatTypeName?.toString()?.includes('NotSet') && arr[index + 1] !== null && arr[index + 1]?.SeatTypeName?.toString()?.includes('Aisle')) {
      return 'gallery'
    }
    else if (arr[index + 1] !== null && arr[index]?.SeatTypeName?.toString()?.includes('Aisle') && arr[index + 1]?.SeatTypeName?.toString()?.includes('Aisle')) {
      return 'gallery'
    }
    else if (arr[index + 1] !== null && arr[index]?.SeatTypeName?.toString()?.includes('Aisle') && arr[index + 1]?.SeatTypeName?.toString()?.includes('NotSet')) {
      return 'gallery'
    }
    else {
      return '';
    }
  }
  //#endregion

  //#region set wing classes on wing seats
  const getSeatTypeClass = (index:any, rowIndex:any, rowArr:any) => {
    // rowArr?.[rowIndex]?.seats?.map((seat, index, arr) => {
    //   if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing") && arr?.[index - 1] === undefined) {
    //     seat.classes = ['windowrow', 'leftWing']
    //   }
    //   else if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing") && arr?.[index + 1] === undefined) {
    //     seat.classes = ['windowrow', 'rightWing']
    //   }
    //   else if (arr?.[index]?.SeatTypeName?.toString()?.includes("Wing")) {
    //     seat.classes = ['windowrow']
    //   }
    // })

    let classes = '';

    if (rowArr?.[rowIndex]?.seats?.[index]?.SeatTypeName?.toString()?.includes("Wing") && rowArr?.[rowIndex]?.seats?.[index - 1] === undefined) {
      classes = `${classes} windowrow leftWing`;
    }
    else if (rowArr?.[rowIndex]?.seats?.[index]?.SeatTypeName?.toString()?.includes("Wing") && rowArr?.[rowIndex]?.seats?.[index + 1] === undefined) {
      classes = `${classes} windowrow rightWing`;
    }
    else if (rowArr?.[rowIndex]?.seats?.[index]?.SeatTypeName?.toString()?.includes("Wing")) {
      classes = `${classes} windowrow`;
    }

    return classes;
  }
  //#endregion

  //#region select seat function
  const handleSelectSeat = (seat:any, flightNumber:any, paxType:any, id:any, e:any, isRemove:any) => {
    setSeatDynamicCollection(
      seatDynamicCollection?.map((seatDynamic:any) => {
        seatDynamic?.rowSeats?.map((obj:any) => {
          obj?.seats?.map((seatObj:any) => {

            if (isRemove) {
              // remove the selected seat if isRemove = true
              if (seatObj?.flightNumber === flightNumber && seatObj?.paxType?.trim()?.length > 0 && (seatObj?.paxType === `${paxType}${id}`)) {
                seatObj.paxType = ''
              }
            }
            else {
              // select the seat
              if (seatObj?.flightNumber === flightNumber && seatObj?.paxType?.trim()?.length > 0 && (seatObj?.paxType === `${paxType}${id}`)) {
                seatObj.paxType = ''
              }
              if (seatObj?.flightNumber === flightNumber && seatObj?.code === seat?.code) {
                if (e.target.checked) {
                  seatObj.paxType = `${paxType}${id}`
                }
                else {
                  seatObj.paxType = ''
                }
              }

            }
            return seatObj;
          })
          return obj;
        })
        return seatDynamic;
      }))
  }
  //#endregion

  //#region set seat background color
  const getSeatDesignCode = (isAvailable:any, isPaxType:any, seatTypeName:any, price:any) => {
    if (isAvailable) {
      if (isPaxType) {
        return 'selected_seat'
      }
      else {
        // if (seatTypeName?.toLowerCase()?.includes('quiet'?.toLowerCase())) {
        //   return 'quiet_zone'
        // }
        // if (seatTypeName?.toLowerCase()?.includes('bulkhead'?.toLowerCase())) {
        //   return 'bulkhead_seat'
        // }
        if (price === 0) {
          return 'blue_bg'
        }
        if (price >= 1 && price <= 300) {
          return 'orange_bg'
        }
        if (price >= 301 && price <= 600) {
          return 'purple_bg'
        }
        if (price >= 601 && price <= 900) {
          return 'light_orange_bg'
        }
        if (price >= 901) {
          return 'yellow_bg'
        }
      }
    }
    else {
      return 'occupied_seat seat_not_available';
    }
  }
  //#endregion

  //#region handle tooltip
  const [tooltip, setTooltip] = useState({ content: null, code: '' });
  const tooltipRef = useRef(null);

  const handleEnter = (content:any, code:any) => {
    setTooltip((prev) => ({ ...prev, content: content, code: code }));
  };

  const handleLeave = () => {
    setTooltip((prev) => ({ ...prev, content: null, code: '' }));
  };
  //#endregion

  // const getTRClasses = (seats) => {
  //   const hasLeftWing = seats?.some(
  //     seat => seat?.classes?.includes('windowrow') && seat?.classes?.includes('leftWing')
  //   );
  //   const hasRightWing = seats?.some(
  //     seat => seat?.classes?.includes('windowrow') && seat?.classes?.includes('rightWing')
  //   );

  //   const trClass = `table_seat ${hasLeftWing ? 'has-leftWing' : ''} ${hasRightWing ? 'has-rightWing' : ''}`;
  //   // return trClass;
  //   return '';
  // }

  //#region display seats 
  const displaySeatsData = (collection:any, rowIndex:any, rowArr:any) => {
    let seats:any = [];
    columns?.temp?.map((col:any, index:any) => (
      seats?.push(
        <td key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${col?.seatNo}${rowIndex}key`} className={`position-relative ${getSeatTypeClass(index, rowIndex, rowArr)} `} >
          {
            collection?.map((seatColl:any, seatIndex:any, arr:any) => {
              return (
                col?.seatNo?.toString() === seatColl?.seatNo &&
                <React.Fragment key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}${seatIndex}seatkey`}>
                  <input
                    type="radio"
                    name={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}seat`}
                    id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}`}
                    className="d-none"
                    checked={seatColl?.paxType === `${pass?.PaxType}${pass?.id}` ? true : false}
                    onChange={(e) => handleSelectSeat(seatColl, flight?.flightNumber, pass?.PaxType, pass?.id, e, false)}
                    onClick={(e) => {
                      if (seatColl?.flightNumber === flight?.flightNumber && seatColl?.paxType?.trim()?.length > 0 && (seatColl?.paxType === `${pass?.PaxType}${pass?.id}`)) {
                        handleSelectSeat(seatColl, flight?.flightNumber, pass?.PaxType, pass?.id, e, true)
                      }
                    }}
                    disabled={seatColl?.availablityType !== 1 || (seatColl?.paxType?.trim()?.length > 0 && (seatColl?.paxType !== `${pass?.PaxType}${pass?.id}`)) ? true : false}
                  />


                  <label
                    htmlFor={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}`}
                    className={`position-relative btn ${seatColl?.paxType?.trim()?.length > 0 && (seatColl?.paxType !== `${pass?.PaxType}${pass?.id}`) ? 'cursor_default' : ''}  p-0 seat ${setGallarySpace(seatIndex, arr)} ${getSeatDesignCode(seatColl?.availablityType === 1 ? true : false, seatColl?.paxType?.trim()?.length > 0 ? true : false, seatColl?.SeatTypeName, seatColl?.price)} `}
                    onMouseEnter={() => handleEnter(
                      seatColl?.availablityType === 1 ?
                        <>
                          <div> Seat No: {seatColl?.code} </div>
                          <div> Price: ₹ {seatColl?.price} </div>
                        </>
                        :
                        null
                      ,
                      seatColl?.code
                    )}
                    onMouseLeave={handleLeave}
                    onTouchStart={() => handleEnter(
                      seatColl?.availablityType === 1 ?
                        <>
                          <div> Seat No: {seatColl?.code} </div>
                          <div> Price: ₹ {seatColl?.price} </div>
                        </>
                        :
                        null
                      ,
                      seatColl?.code
                    )}
                    onTouchEnd={handleLeave}
                  >
                    <div className="seat_color_code">
                      <div className="seat_color_code_sub"> {seatColl?.availablityType === 1 ? seatColl?.code : 'x'} </div>
                    </div>

                    {seatColl?.code === tooltip?.code && tooltip?.content && (
                      <div
                        ref={tooltipRef}
                        className="custom-tooltip"
                        style={{
                          transform: 'translate(-33%,-90%)'
                        }}
                      >
                        {tooltip?.content}
                      </div>
                    )}

                  </label>

                  {/* <CustomTooltip
                    id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}tooltip`}
                    content={
                      <div>
                        <div> Seat No: {seatColl?.code} </div>
                        <div> Price: ₹ {seatColl?.price} </div>
                      </div>
                    }
                  >
                    <label
                      htmlFor={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}`}
                      className={`position-relative btn ${seatColl?.paxType?.trim()?.length > 0 && (seatColl?.paxType !== `${pass?.PaxType}${pass?.id}`) ? 'cursor_default' : ''}  p-0 seat ${setGallarySpace(seatIndex, arr)} ${getSeatDesignCode(seatColl?.availablityType === 1 ? true : false, seatColl?.paxType?.trim()?.length > 0 ? true : false, seatColl?.SeatTypeName)} `}
                      data-custom-tooltip-id={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${seatColl?.code}tooltip`}

                    >
                      <div className="seat_color_code">
                        <div className="seat_color_code_sub"> {seatColl?.code} </div>
                      </div>
                    </label>
                  </CustomTooltip> */}


                </React.Fragment>
              )
            })
          }
        </td >
      )
    ))
    return seats;
  }
  //#endregion

  return (
    <>
      {
        row?.rowSeats?.length > 1 ?
          <div className={"seat-container plane-design-main d-flex justify-content-center"}>
            <ul className="legend">
              <li className="legend-item fw-bold px-1">
                Seat Charges
              </li>
              <li className="legend-item blue_bg">
                <div className="legend_item_bg">
                  Free
                </div>
              </li>
              <li className="legend-item orange_bg">
                <div className="legend_item_bg">
                  1-300
                </div>
              </li>
              <li className="legend-item purple_bg">
                <div className="legend_item_bg">
                  301-600
                </div>
              </li>
              <li className="legend-item light_orange_bg">
                <div className="legend_item_bg">
                  601-900
                </div>
              </li>
              <li className="legend-item yellow_bg">
                <div className="legend_item_bg">
                  901 to Above
                </div>
              </li>

            </ul>

            <div className="plane-cabin">
              <div className="plane-passenger pb-1">
                <div className="entrance_title mb-3"> Front Entrance </div>
                <div className="entrance_title mb-3"> Deck 1 </div>
                <table className={"seat-map"}>

                  <tbody>
                    {
                      row?.rowSeats?.length > 1 && row?.rowSeats?.map((seat:any, index:any, rowArr:any) => {
                        return (
                          <React.Fragment key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${index}parent`} >
                            {(() => {
                              if (index > 0) {
                                return (
                                  <React.Fragment key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${index}child`}>
                                    {
                                      seat?.seats?.[0]?.SeatTypeName?.toString()?.includes("Exit") &&
                                      <tr key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}exitdoorkey`} >
                                        <td colSpan={columns?.temp?.length} className={`position-relative exit_door ${seat?.seats?.[0]?.SeatTypeName?.toString()?.includes("Wing") ? 'exit_wing' : ''} `} >
                                          <div>
                                            Emergency Door
                                          </div>
                                        </td>
                                      </tr>
                                    }
                                    <tr className={`table_seat`} key={`flight${flightIndex + 1}${flight?.flightNumber}${getPassengerType(pass?.PaxType)}${pass?.id}${index}seatrowkey`}>
                                      {displaySeatsData(seat?.seats, index, rowArr)}
                                    </tr>
                                  </React.Fragment>
                                )
                              }
                            })()}
                          </React.Fragment>
                        )
                      })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          :
          <div className="height200 align-content-center w-100">
            <div className="text-center fw-bold text-danger">
              Seat Not Avalilable
            </div>
          </div>
      }
    </>
  )
};

export default SeatBooking;

